import React from 'react';
import PortableText from 'react-portable-text';
import cx from 'classnames';

import SwitchLink from '@components/links/switchLink';
import { SanityImage } from './sanityImage';

const SimplePortableText = ({
  text,
  centerText = false,
  className,
  white,
  ...props
}) => {
  const btnSettings = white
    ? 'bg-white text-white hover:!text-teal'
    : 'bg-teal text-teal hover:!text-white';

  return text ? (
    <PortableText
      content={text}
      serializers={{
        figure: (props) => (
          <SanityImage image={props} className='w-full rounded-2xl' />
        ),
        strong: (props) => <span {...props} className='font-bold' />,
        highlight: (props) => <span {...props} className='text-teal' />,
        seasonalFont: (props) => <span {...props} className='font-epicene' />,
        specialCharacter: (props) => (
          <span {...props} className='font-season-unique' />
        ),
        normal: (props) => <p {...props} className='font-display richH6' />,
        h1: (props) => <h1 {...props} className='font-display richH0' />,
        h2: (props) => <h2 {...props} className='font-display richH1' />,
        h3: (props) => <h3 {...props} className='font-display richH2' />,
        h4: (props) => <h4 {...props} className='font-display richH3' />,
        h5: (props) => <h5 {...props} className='font-display richH4' />,
        h6: (props) => <h6 {...props} className='font-display richH5' />,
        ul: (props) => (
          <ul {...props} className='list-disc  pl-[1.25em] ml-0 richH6' />
        ),
        ol: (props) => (
          <ol {...props} className='list-disc pl-[1.25em] ml-0 richH6' />
        ),
        externalLink: (props) => (
          <SwitchLink
            {...props}
            className={`btn-standard ${btnSettings} bg-opacity-10 mt-2 inline-block`}
          />
        ),
        donateButton: (props) => (
          <SwitchLink
            {...props}
            className={`btn-standard ${btnSettings} bg-opacity-10 mt-2 inline-block`}
          />
        ),
        pageLink: (props) => (
          <SwitchLink
            {...props}
            className={`btn-standard ${btnSettings} bg-opacity-10 mt-2 inline-block`}
          />
        ),
        pageAnchorLink: (props) => (
          <SwitchLink
            {...props}
            className={`btn-standard ${btnSettings} bg-opacity-10 mt-2 inline-block`}
          />
        ),
        anchorLink: (props) => (
          <SwitchLink
            {...props}
            className={`btn-standard ${btnSettings} bg-opacity-10 mt-2 inline-block`}
          />
        ),
        subscriptionButton: (props) => (
          <></>
          // reinstate when season reopens
          // <SubscriptionButton
          //   {...props}
          //   className={`${btnSettings} bg-opacity-10 mt-2 inline-block`}
          // />
        ),
      }}
      className={cx(className, {
        'portable-text flex flex-col gap-y-4 relative': true,
        'text-white': white,
        'text-grey': !white,
      })}
      {...props}
    />
  ) : null;
};

export default SimplePortableText;
